export default __webpack_public_path__ + "static/media/presentIcon.50f643cf.svg";